import ApiFetcher from "../utils/ApiFetcher";
import { put, call } from "redux-saga/effects";
import { makeQueryString } from "../utils/urls";
import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaSearchSuccess,
  sagaCreateSuccess,
  sagaUpdateSuccess
} from "../actions/ActionTypes";
import { showSuccessMsg, showErrorMsg } from "../actions";
const EVENTS = "EVENTS";
const EVENT = "EVENT";
const apiFetcher = new ApiFetcher();
export function* fetchEvents(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `events?${queryString}`);
    yield put({
      type: sagaListSuccess(EVENTS),
      data: res.data
    });
  } catch (e) {}
}

export function* searchEvents(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `events?${queryString}`);
    yield put({
      type: sagaSearchSuccess(EVENTS),
      data: res.data
    });
  } catch (e) {}
}

export function* fetchEvent(action) {
  try {
    const res = yield call(apiFetcher.find, "events", action.id);
    yield put({
      type: sagaOneSuccess(EVENT),
      data: res.data
    });
  } catch (e) {}
}

export function* createEvent(action) {
  try {
    const res = yield call(apiFetcher.create, "events", { event: action.data });
    yield put({
      type: sagaCreateSuccess(EVENT),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Event created successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) {}
}

export function* updateEvent(action) {
  //restore old data to form when save fails -> probably in reducer
  try {
    const res = yield call(
      apiFetcher.update,
      "events",
      { event: action.data },
      action.id
    );
    yield put({
      type: sagaUpdateSuccess(EVENT),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Event details updated successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) {}
}



// WEBPACK FOOTER //
// ./src/sagas/events.js